<template>
  <div>
    <v-row align="center">
      <v-col>
        <h3 class="ma-1">Nota Fiscal: #{{ item.number }}</h3>
        <v-chip small :color="resolveStatusVariant(item.status)"
          :class="`${resolveStatusVariant(item.status)}--text`" class="font-weight-semibold text-capitalize">
          {{ resolveStatusDescription(item.status) }}
        </v-chip>
      </v-col>
    </v-row>
    <v-row class="mt-2">
      <v-col cols="12" md="9">
        <v-card class="px-2">
          <v-card-text>
            <v-card-title>
              <h4>Dados da Nota</h4>
            </v-card-title>
            <v-row>
              <v-col cols="12" md="6">
                <strong>Chave de Acesso:</strong> <br>
                <span class="grey--text">{{ item.chave || '---' }}</span>
              </v-col>
              <v-col cols="12" md="3">
                <strong>Valor:</strong> <br>
                <span class="success--text font-weight-bold">{{ (item.value / 100) | moneyBr }}</span>
              </v-col>
               <v-col cols="12" md="3">
                <strong>Emissão:</strong> <br>
                <span class="grey--text">{{ item.emited_at | dateBR }}</span>
              </v-col>
            </v-row>
            <v-row class="mt-4">
               <v-col cols="12">
                <strong>Mensagem:</strong> <br>
                <div class="grey--text text--darken-1 pa-3 grey lighten-4 rounded">
                  {{ item.messages || 'Nenhuma mensagem registrada.' }}
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Se houver produtos, listar aqui. Assumindo estrutura similar a OrderDetails -->
        <!-- Como não tenho certeza se a API retorna 'products' ou algo assim, vou deixar preparado -->
      </v-col>

      <v-col cols="12" md="3" class="d-flex justify-end">
        <v-card class="px-4 w-full">
          <v-row class="mt-4 d-flex justify-space-between">
            <v-col cols="12">
               <div>
                <strong>Cliente</strong>
              </div>
            </v-col>
            <v-col cols="3" class="text-center" v-if="item.customer">
              <v-avatar size="46" color="primary">
                <span class="white--text text-h6">{{ item.customer.name.charAt(0) }}</span>
              </v-avatar>
            </v-col>
            <v-col cols="9" v-if="item.customer">
              <div>
                <strong>{{ item.customer.name | toCamelCase }}</strong>
              </div>
              <small v-if="item.customer.document">Doc: {{ item.customer.document | cpfCnpj }}</small>
            </v-col>
          </v-row>

          <v-divider class="my-3"></v-divider>

          <v-row class="mt-1" v-if="item.customer">
            <v-col cols="12">
              <div>
                <strong>Contato</strong>
              </div>
              <small>{{ item.customer.email }}</small> <br />
              <small>{{ item.customer.phone | phone }}</small>
            </v-col>
          </v-row>
          
           <v-divider class="my-3"></v-divider>
           
           <v-row class="mb-4">
             <v-col cols="12">
               <v-btn block color="primary" outlined @click="$router.go(-1)">
                 Voltar
               </v-btn>
             </v-col>
           </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import statusNotaMixin from "@/util/mixins/statusNotaMixin";

export default {
  name: "InvoiceDetails",
  mixins: [statusNotaMixin], // Reusing status logic
  data() {
    return {
      item: {
        number: '',
        status: '',
        chave: '',
        value: 0,
        emited_at: '',
        messages: '',
        customer: {
          name: '',
          document: '',
          email: '',
          phone: ''
        }
      },
      loading: false,
    };
  },
  created() {
    this.getInvoice();
  },
  methods: {
    getInvoice() {
      this.loading = true;
      const id = this.$route.params.id;
      // Ajuste para usar o endpoint correto se diferente
      // Assumindo que o endpoint /nota-fiscal-produto retorna detalhe se passado ID, 
      // ou se existe um /nota-fiscal-produto/{id} específico.
      // Vou tentar usar um show, se não existir, precisarei verificar.
      // Observando productsInvoices.vue, eles usam /nota-fiscal-produto para listar.
      // Geralmente em Laravel resources, GET /nota-fiscal-produto/{id} é o show.
      
      this.$http
        .$get(`/nota-fiscal-produto/${id}`)
        .then((response) => {
          // Ajuste conforme o retorno da API. 
          // Se retornar paginado ou envolto em 'data'.
          this.item = response.data || response; 
        })
        .catch((error) => {
          console.log(error);
          this.$toast.error("Erro ao carregar detalhes da nota.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
</style>
